var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanklesslogo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278.78 272.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e9242f;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.83,
    y: 10.98,
    width: 237.45,
    height: 237.45,
    rx: 44.6,
    ry: 44.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.21,
    y: 186.07,
    width: 80.69,
    height: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.94,128.33c0,9.89-4.46,18.21-11.25,23.49-6.79,5.28-16.66,7.92-29.6,7.92h-39.93V54.14h37.97c11.35,0,21.89,1.22,28.39,6.03,6.5,4.8,9.75,11.38,9.75,19.74,0,10.18-5.68,18.17-15.91,23.07,6.88,1.73,12.04,4.91,15.45,9.54,3.42,4.63,5.13,9.9,5.13,15.81ZM121.43,93.35h16.04c5.28,0,9.17-.83,11.66-2.48,2.49-1.65,3.74-4.41,3.74-8.26,0-3.47-1.21-6.08-3.64-7.83-2.43-1.75-6.64-2.62-12.65-2.62h-15.16v21.19ZM121.55,139.41h18.37c12.07,0,18.11-4.39,18.11-13.17,0-4.56-1.4-7.9-4.19-10.01-2.79-2.11-7.86-3.16-15.22-3.16h-17.06v26.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanklesslogo01);
export default __webpack_public_path__ + "static/media/bankless logo-01.89f7e1f7d0805b13015ddbb3f71790f7.svg";
export { ForwardRef as ReactComponent };